 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import A3_TITLE from '@/components/03_Title'
 import A781504095785 from '@/components/9781504095785'
 import A7815040957850 from '@/components/9781504095785-0'
 import A7815040957851 from '@/components/9781504095785-1'
 import A7815040957852 from '@/components/9781504095785-2'
 import A7815040957853 from '@/components/9781504095785-3'
 import A7815040957854 from '@/components/9781504095785-4'
 import A7815040957855 from '@/components/9781504095785-5'
 import A7815040957856 from '@/components/9781504095785-6'
 import A7815040957857 from '@/components/9781504095785-7'
 import A7815040957858 from '@/components/9781504095785-8'
 import A7815040957859 from '@/components/9781504095785-9'
 import A78150409578510 from '@/components/9781504095785-10'
 import A78150409578511 from '@/components/9781504095785-11'
 import A78150409578512 from '@/components/9781504095785-12'
 import A78150409578513 from '@/components/9781504095785-13'
 import A78150409578514 from '@/components/9781504095785-14'
 import A78150409578515 from '@/components/9781504095785-15'
 import A78150409578516 from '@/components/9781504095785-16'
 import A78150409578517 from '@/components/9781504095785-17'
 import A78150409578518 from '@/components/9781504095785-18'
 import A78150409578519 from '@/components/9781504095785-19'
 import A78150409578520 from '@/components/9781504095785-20'
 import A78150409578521 from '@/components/9781504095785-21'
 import A78150409578522 from '@/components/9781504095785-22'
 import A78150409578523 from '@/components/9781504095785-23'
 import A78150409578524 from '@/components/9781504095785-24'
 import A78150409578525 from '@/components/9781504095785-25'
 import A78150409578526 from '@/components/9781504095785-26'
 import A78150409578527 from '@/components/9781504095785-27'
 import A78150409578528 from '@/components/9781504095785-28'
 import A78150409578529 from '@/components/9781504095785-29'
 import A78150409578530 from '@/components/9781504095785-30'
 import A78150409578531 from '@/components/9781504095785-31'
 import A78150409578532 from '@/components/9781504095785-32'
 import A78150409578533 from '@/components/9781504095785-33'
 import A78150409578534 from '@/components/9781504095785-34'
 import A78150409578535 from '@/components/9781504095785-35'
 import A78150409578536 from '@/components/9781504095785-36'
 import A78150409578537 from '@/components/9781504095785-37'
 import A78150409578538 from '@/components/9781504095785-38'
 import A78150409578539 from '@/components/9781504095785-39'
 import A78150409578540 from '@/components/9781504095785-40'
 import A78150409578541 from '@/components/9781504095785-41'
 import A78150409578542 from '@/components/9781504095785-42'
 import A78150409578543 from '@/components/9781504095785-43'
 import A78150409578544 from '@/components/9781504095785-44'
 import A78150409578545 from '@/components/9781504095785-45'
 import A78150409578546 from '@/components/9781504095785-46'
 import A78150409578547 from '@/components/9781504095785-47'
 import A78150409578548 from '@/components/9781504095785-48'
 import A78150409578549 from '@/components/9781504095785-49'
 import A78150409578550 from '@/components/9781504095785-50'
 import A78150409578551 from '@/components/9781504095785-51'
 import A78150409578552 from '@/components/9781504095785-52'
 import A78150409578553 from '@/components/9781504095785-53'
 import A78150409578554 from '@/components/9781504095785-54'
 import A78150409578555 from '@/components/9781504095785-55'
 import A78150409578556 from '@/components/9781504095785-56'
 import A78150409578557 from '@/components/9781504095785-57'
 import A78150409578558 from '@/components/9781504095785-58'
 import A78150409578559 from '@/components/9781504095785-59'
 import A78150409578560 from '@/components/9781504095785-60'
 import A78150409578561 from '@/components/9781504095785-61'
 import A78150409578562 from '@/components/9781504095785-62'
 import A78150409578563 from '@/components/9781504095785-63'
 import A78150409578564 from '@/components/9781504095785-64'
 import A78150409578565 from '@/components/9781504095785-65'
 import A78150409578566 from '@/components/9781504095785-66'
 import A78150409578567 from '@/components/9781504095785-67'
 import A78150409578568 from '@/components/9781504095785-68'
 import A78150409578569 from '@/components/9781504095785-69'
 import A78150409578570 from '@/components/9781504095785-70'
 import A78150409578571 from '@/components/9781504095785-71'
 import A78150409578572 from '@/components/9781504095785-72'
 import A78150409578573 from '@/components/9781504095785-73'
 import A78150409578574 from '@/components/9781504095785-74'
 import A78150409578575 from '@/components/9781504095785-75'
 import A78150409578576 from '@/components/9781504095785-76'
 import A78150409578577 from '@/components/9781504095785-77'
 import A78150409578578 from '@/components/9781504095785-78'
 import A78150409578579 from '@/components/9781504095785-79'
 import A78150409578580 from '@/components/9781504095785-80'
 import A78150409578581 from '@/components/9781504095785-81'
 import A78150409578582 from '@/components/9781504095785-82'
 import A78150409578583 from '@/components/9781504095785-83'
 import A78150409578584 from '@/components/9781504095785-84'
 import A78150409578585 from '@/components/9781504095785-85'
 import A78150409578586 from '@/components/9781504095785-86'
 import A78150409578587 from '@/components/9781504095785-87'
 import A78150409578588 from '@/components/9781504095785-88'
 import A78150409578589 from '@/components/9781504095785-89'
 import A78150409578590 from '@/components/9781504095785-90'
 import LOVE_2 from '@/components/love_2'
 import A78150409578591 from '@/components/9781504095785-91'
 import A78150409578592 from '@/components/9781504095785-92'
 import COPYRIGHT from '@/components/Copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/03_Title",
 			"name" : "03_Title",
 			"component" : A3_TITLE
 		},
 		{
 			"path" : "/9781504095785",
 			"name" : "9781504095785",
 			"component" : A781504095785
 		},
 		{
 			"path" : "/9781504095785-0",
 			"name" : "9781504095785-0",
 			"component" : A7815040957850
 		},
 		{
 			"path" : "/9781504095785-1",
 			"name" : "9781504095785-1",
 			"component" : A7815040957851
 		},
 		{
 			"path" : "/9781504095785-2",
 			"name" : "9781504095785-2",
 			"component" : A7815040957852
 		},
 		{
 			"path" : "/9781504095785-3",
 			"name" : "9781504095785-3",
 			"component" : A7815040957853
 		},
 		{
 			"path" : "/9781504095785-4",
 			"name" : "9781504095785-4",
 			"component" : A7815040957854
 		},
 		{
 			"path" : "/9781504095785-5",
 			"name" : "9781504095785-5",
 			"component" : A7815040957855
 		},
 		{
 			"path" : "/9781504095785-6",
 			"name" : "9781504095785-6",
 			"component" : A7815040957856
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js